import keycloakAxios from '@/services/axios';

export const removeEmployee = async (employeeId: string, companyId: string) => {
  const endpoint = `company/${companyId}/employee/${employeeId}`;

  const response = await keycloakAxios.delete(endpoint);

  if (response.status >= 300) {
    throw new Error(
      `Error removing employee: Invalid status code: ${response.status}`
    );
  }

  return response.data;
};
